import { Component, Input, OnInit } from '@angular/core';

import { LocService } from '../shared/shared-context/loc.service';

@Component({
    selector: 'ohp-create-menu-placeholder-tile',
    templateUrl: './create-menu-placeholder-tile.component.html'
})
export class CreateMenuPlaceHolderTileComponent implements OnInit {
    @Input('forceWhiteBackground') public fullBleedTheming: boolean = false;

    public createPlaceholderText: string;
    public createPlaceholderAriaLabel: string;

    constructor(private readonly locService: LocService) {}

    public ngOnInit(): void {
        this.createPlaceholderText = this.locService.MruCreateTileText;
        this.createPlaceholderAriaLabel = this.locService.MruCreateLinkAriaLabelTitle;
    }
}
